import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { classicBusinessProjectFormSubmitRoute } from '@atlassian/jira-router-routes-business-routes/src/classicBusinessProjectFormSubmitRoute.tsx';
import { formSubmitPageEntrypoint } from './ui/spa/business/form-submit/index.tsx';

export const classicBusinessProjectFormSubmitRouteEntry = createEntry(
	classicBusinessProjectFormSubmitRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-submit-view',
		layout: chromelessLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarCore,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		entryPoint: () => formSubmitPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormSubmitRouteEntry.tsx',
				whichExportToUse: 'classicBusinessProjectFormSubmitRouteEntry',
			},

			enabled: true,
		},
	}),
);
